import { __rest } from 'tslib';
import { useMemo } from 'react';
import * as sorting from '../utils/sorting.js';

const sortingTypes = Object.keys(sorting);
const isValidSortType = (sortType) => typeof sortType === 'string' && sortingTypes.includes(sortType);
const useModifiedColumns = (columns) => {
    return useMemo(() => columns.map((_a) => {
        var { minWidth = 50, sortType = 'text' } = _a, rest = __rest(_a, ["minWidth", "sortType"]);
        let sortFunc = sortType;
        if (isValidSortType(sortType)) {
            sortFunc = sorting[sortType];
        }
        return Object.assign({ minWidth, sortType: sortFunc }, rest);
    }), [columns]);
};

export { useModifiedColumns as default };
//# sourceMappingURL=useModifiedColumns.js.map
